/**
 * Global CSS reset for webmotors-consumer-chat
 * Replicates the garagem's scss/_reset.scss so the chat layout
 * looks identical to the original.
 */

/* ── Reset (matches garagem _reset.scss) ── */

* {
  margin: 0;
  padding: 0;
  border: medium none;
  outline: none;
  font-family: 'Poppins', sans-serif;
  font-weight: normal;
  font-style: normal;
  box-sizing: border-box;
}

*::before,
*::after {
  box-sizing: border-box;
}

button {
  cursor: pointer;
  background: transparent;
}

input,
textarea {
  appearance: none;
  -webkit-appearance: none;
  border-radius: 0;
  box-shadow: none;
}

ul,
ol {
  list-style: none;
}

a {
  text-decoration: none;
  cursor: pointer;
}

strong,
b,
th {
  font-weight: bold;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-weight: 600;
}

strong,
b,
em,
i,
span,
a {
  font-size: inherit;
  color: inherit;
}

img {
  max-width: 100%;
  display: block;
}

/* ── Page-level styles ── */

html,
body {
  height: 100%;
  font-size: 14px;
  line-height: 1.5;
  color: #000;
  background: #ecedf2;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

#root {
  height: 100%;
  display: flex;
  flex-direction: column;
}

/* ── Mobile scroll lock (toggled via document.body.classList) ── */

body.chatOpen {
  overflow: hidden;
  position: fixed;
  width: 100%;
  height: 100%;
  touch-action: none;
}
